import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const DownloadIcon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
        return (
            <MuiIcon {...props}
                     ref={ref}
            >{'\uf090'}</MuiIcon>
        );
    }
)
